/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_AffiliatesInputs */

const en_nav_affiliates = /** @type {(inputs: Nav_AffiliatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affiliates`)
};

const zh_hans1_nav_affiliates = /** @type {(inputs: Nav_AffiliatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推广计划`)
};

const pt_br2_nav_affiliates = /** @type {(inputs: Nav_AffiliatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afiliados`)
};

const es_nav_affiliates = /** @type {(inputs: Nav_AffiliatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afiliados`)
};

const fr_nav_affiliates = /** @type {(inputs: Nav_AffiliatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affiliés`)
};

const de_nav_affiliates = /** @type {(inputs: Nav_AffiliatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partnerprogramm`)
};

const ru_nav_affiliates = /** @type {(inputs: Nav_AffiliatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Партнёрам`)
};

const it_nav_affiliates = /** @type {(inputs: Nav_AffiliatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affiliati`)
};

/**
* | output |
* | --- |
* | "Affiliates" |
*
* @param {Nav_AffiliatesInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const nav_affiliates = /** @type {((inputs?: Nav_AffiliatesInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_AffiliatesInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_nav_affiliates(inputs)
	if (locale === "pt-BR") return pt_br2_nav_affiliates(inputs)
	if (locale === "es") return es_nav_affiliates(inputs)
	if (locale === "fr") return fr_nav_affiliates(inputs)
	if (locale === "de") return de_nav_affiliates(inputs)
	if (locale === "ru") return ru_nav_affiliates(inputs)
	if (locale === "it") return it_nav_affiliates(inputs)
	return en_nav_affiliates(inputs)
});